"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstimatedValuesWrapperByPropertyType$ = exports.EstimatedValuesWrapperByPropertyType$outboundSchema = exports.EstimatedValuesWrapperByPropertyType$inboundSchema = void 0;
exports.estimatedValuesWrapperByPropertyTypeToJSON = estimatedValuesWrapperByPropertyTypeToJSON;
exports.estimatedValuesWrapperByPropertyTypeFromJSON = estimatedValuesWrapperByPropertyTypeFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const fastapikrakenendpointsstatsmodelssalesnationalgetestimatedvaluesnationalresponsesstatslatestestimate_js_1 = require("./fastapikrakenendpointsstatsmodelssalesnationalgetestimatedvaluesnationalresponsesstatslatestestimate.js");
const pricechangesestimatedvalues_js_1 = require("./pricechangesestimatedvalues.js");
const propertytype_js_1 = require("./propertytype.js");
const statsdelta_js_1 = require("./statsdelta.js");
/** @internal */
exports.EstimatedValuesWrapperByPropertyType$inboundSchema = z.object({
    delta: statsdelta_js_1.StatsDelta$inboundSchema,
    latest_estimate: fastapikrakenendpointsstatsmodelssalesnationalgetestimatedvaluesnationalresponsesstatslatestestimate_js_1.FastapiKrakenEndpointsStatsModelsSalesNationalGetEstimatedValuesNationalResponsesStatsLatestEstimate$inboundSchema,
    property_type: propertytype_js_1.PropertyType$inboundSchema,
    values: z.array(pricechangesestimatedvalues_js_1.PriceChangesEstimatedValues$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "latest_estimate": "latestEstimate",
        "property_type": "propertyType",
    });
});
/** @internal */
exports.EstimatedValuesWrapperByPropertyType$outboundSchema = z.object({
    delta: statsdelta_js_1.StatsDelta$outboundSchema,
    latestEstimate: fastapikrakenendpointsstatsmodelssalesnationalgetestimatedvaluesnationalresponsesstatslatestestimate_js_1.FastapiKrakenEndpointsStatsModelsSalesNationalGetEstimatedValuesNationalResponsesStatsLatestEstimate$outboundSchema,
    propertyType: propertytype_js_1.PropertyType$outboundSchema,
    values: z.array(pricechangesestimatedvalues_js_1.PriceChangesEstimatedValues$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        latestEstimate: "latest_estimate",
        propertyType: "property_type",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var EstimatedValuesWrapperByPropertyType$;
(function (EstimatedValuesWrapperByPropertyType$) {
    /** @deprecated use `EstimatedValuesWrapperByPropertyType$inboundSchema` instead. */
    EstimatedValuesWrapperByPropertyType$.inboundSchema = exports.EstimatedValuesWrapperByPropertyType$inboundSchema;
    /** @deprecated use `EstimatedValuesWrapperByPropertyType$outboundSchema` instead. */
    EstimatedValuesWrapperByPropertyType$.outboundSchema = exports.EstimatedValuesWrapperByPropertyType$outboundSchema;
})(EstimatedValuesWrapperByPropertyType$ || (exports.EstimatedValuesWrapperByPropertyType$ = EstimatedValuesWrapperByPropertyType$ = {}));
function estimatedValuesWrapperByPropertyTypeToJSON(estimatedValuesWrapperByPropertyType) {
    return JSON.stringify(exports.EstimatedValuesWrapperByPropertyType$outboundSchema.parse(estimatedValuesWrapperByPropertyType));
}
function estimatedValuesWrapperByPropertyTypeFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.EstimatedValuesWrapperByPropertyType$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'EstimatedValuesWrapperByPropertyType' from JSON`);
}
//# sourceMappingURL=estimatedvalueswrapperbypropertytype.js.map